
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as labgHLY2Hgzx07fDS8FCwd7T3EnrLW2eKBthJYVjPON_45YMMeta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/lab.vue?macro=true";
import { default as indexeL1jKrhgK_45ddZfFNRIMHbwhr_pdDByVYyMeyOeF9PA0Meta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/index.vue?macro=true";
import { default as hobbiesHQUZC1b12KRoVLXDhd5JgM1uiszycQjlpM6w_D_U9xIMeta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/hobbies.vue?macro=true";
import { default as studies6t4KGuRSBpuPcbuPCseAI6_45LaqrHh_45LaRjmrmHTPLp4Meta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/studies.vue?macro=true";
import { default as indexI_45QvuJVEFLCpQxzNmHWImD8pLd55CfO8erLcEPJf35AMeta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/resume/index.vue?macro=true";
import { default as indexnhJk30cz9mdcd_45eg3koN4figJ_45q02gWN9Kq1GYAmWEcMeta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/skills/index.vue?macro=true";
import { default as _91id_93lDHH3adOawt89smYihVOVlw0u0YdkgGDCPxUjfXuShUMeta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/projects/[id].vue?macro=true";
import { default as _91slug_93BWcHhxNU0goaABsG0U8CfWmzgr8sBHqrYIKC9A0af9IMeta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/skills/[slug].vue?macro=true";
import { default as indexuyI2b_45kPhyurzls9EtACx8dkMd2oF7S2QWCWjyLYX3cMeta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/projects/index.vue?macro=true";
import { default as skill_45details_46logic3oQoufZ1dLzmQR2IThsXPSNuJN0tGTPSn9gJFL_452Z2IMeta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/skills/skill-details.logic.ts?macro=true";
import { default as project_45details_46logicnZquXr0DFtU5MwSE2REI_45SwDyHrmBdD8ki10SQVL_fQMeta } from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/projects/project-details.logic.ts?macro=true";
export default [
  {
    name: "lab",
    path: "/lab",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/lab.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/index.vue")
  },
  {
    name: "hobbies",
    path: "/hobbies",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/hobbies.vue")
  },
  {
    name: "studies",
    path: "/studies",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/studies.vue")
  },
  {
    name: "resume",
    path: "/resume",
    meta: indexI_45QvuJVEFLCpQxzNmHWImD8pLd55CfO8erLcEPJf35AMeta || {},
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/resume/index.vue")
  },
  {
    name: "skills",
    path: "/skills",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/skills/index.vue")
  },
  {
    name: "projects-id",
    path: "/projects/:id()",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/projects/[id].vue")
  },
  {
    name: "skills-slug",
    path: "/skills/:slug()",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/skills/[slug].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/projects/index.vue")
  },
  {
    name: "skills-skill-details.logic",
    path: "/skills/skill-details.logic",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/skills/skill-details.logic.ts")
  },
  {
    name: "projects-project-details.logic",
    path: "/projects/project-details.logic",
    component: () => import("/home/runner/work/diegomarmol.com/diegomarmol.com/src/pages/projects/project-details.logic.ts")
  }
]